import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

interface SkuTableLoadingProps {
  colSpan?: number;
}

export const SkuTableLoading: React.FC<SkuTableLoadingProps> = ({
  colSpan = 6,
}) => {
  const { translate } = useFlightTranslation();

  return (
    <tr>
      <td
        colSpan={colSpan}
        style={{
          padding: "12px",
          textAlign: "center",
          borderBottom: "1px solid #ddd",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 1,
          }}
        >
          <CircularProgress size={20} sx={{ mr: 1 }} />
          <Typography variant="body2">
            {translate("Loading SKU data...")}
          </Typography>
        </Box>
      </td>
    </tr>
  );
};
